import { motion } from "framer-motion";

const SERVICES = [
  {
    num: "01",
    title: "Conseil & accompagnement des agences immobilières",
    description:
      "Accompagnement opérationnel des agences immobilières pour structurer leur activité, renforcer leur performance commerciale et développer durablement leur portefeuille.",
    bullets: [
      "Diagnostic d'agence et plan d'action",
      "Optimisation de la performance commerciale",
      "Structuration et organisation interne",
      "Stratégie de développement local",
    ],
  },
  {
    num: "02",
    title: "Apport d'affaires & mise en relation",
    description:
      "Sourcing et qualification de clients vendeurs ou acquéreurs, mise en relation ciblée avec les agences partenaires, et suivi des opportunités jusqu'à leur concrétisation.",
    bullets: [
      "Sourcing de clients qualifiés",
      "Mise en relation ciblée",
      "Recommandation et prescription",
      "Suivi et accompagnement des opportunités",
    ],
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-white py-28 md:py-40 border-t border-[#E5E5E5]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        {/* Section heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mb-20 md:mb-28 max-w-3xl"
        >
          <div className="flex items-center gap-4 mb-8">
            <span className="accent-bar-sm" aria-hidden="true" />
            <span className="text-xs tracking-[0.25em] uppercase text-[#6B7280] font-medium">
              Services
            </span>
          </div>
          <h2
            data-testid="services-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#0A0A0A]"
          >
            Nos domaines<br />
            <span className="italic font-normal">d'intervention.</span>
          </h2>
        </motion.div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          {SERVICES.map((srv, idx) => (
            <motion.article
              key={srv.num}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -6 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.85,
                delay: idx * 0.12,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="service-card group relative p-10 md:p-14 overflow-hidden"
              data-testid={`service-card-${srv.num}`}
            >
              {/* Big number background */}
              <span
                aria-hidden="true"
                className="service-number font-serif absolute -top-2 right-6 text-[8rem] md:text-[10rem] leading-none font-bold pointer-events-none select-none"
              >
                {srv.num}
              </span>

              <div className="relative">
                <span className="block text-xs tracking-[0.25em] uppercase text-[#E10600] font-medium mb-6">
                  — {srv.num}
                </span>

                <h3
                  className="font-serif text-2xl md:text-3xl leading-tight text-[#0A0A0A] tracking-tight mb-6 max-w-md"
                  data-testid={`service-title-${srv.num}`}
                >
                  {srv.title}
                </h3>

                <p
                  className="text-[#374151] font-light leading-relaxed text-[0.95rem] md:text-base max-w-md"
                  data-testid={`service-description-${srv.num}`}
                >
                  {srv.description}
                </p>

                <div className="mt-10 pt-8 border-t border-[#E5E5E5]">
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                    {srv.bullets.map((b) => (
                      <li
                        key={b}
                        className="flex items-start gap-3 text-sm text-[#0A0A0A] font-light"
                        data-testid={`service-bullet-${srv.num}-${b}`}
                      >
                        <span
                          className="mt-[9px] block w-3 h-px bg-[#E10600] flex-shrink-0"
                          aria-hidden="true"
                        />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
